import * as React from 'react';
import { Link } from 'react-router-dom';
import { ConnectKitButton } from 'connectkit';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { Logo } from './Logo';
import { checkAndAddChain } from '../lib/utils';
import theme from '../theme';
import { MENU_ITEMS } from '../constants';

function MobileMenu() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <Box sx={{ mr: 1, display: { xs: 'block', md: 'none' } }}>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        anchor="right"
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#1a202c',
            backgroundImage: 'none',
          },
        }}
      >
        <List sx={{ width: 200, mt: 2 }}>
          {MENU_ITEMS.map((item) => {
            return (
              <ListItem key={item.title} disablePadding sx={{ width: 200 }}>
                <Link
                  key={item.title}
                  to={item.href}
                  style={{
                    textDecoration: 'none',
                    color: 'white',
                  }}
                >
                  <ListItemButton sx={{ width: 200 }}>
                    <ListItemText primary={item.title} />
                  </ListItemButton>
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Drawer>
    </Box>
  );
}

function Header() {
  React.useEffect(() => {
    checkAndAddChain();
  }, []);

  return (
    <Box position="static" py={4}>
      <Container maxWidth="lg" sx={{ my: 1 }}>
        <Toolbar disableGutters>
          <Logo />

          <Box sx={{ flexGrow: 1 }} />

          <Box
            sx={{
              marginRight: 2,
              display: 'flex',
              [theme.breakpoints.down('md')]: {
                display: 'none',
              },
            }}
          >
            {MENU_ITEMS.map((item) => {
              return (
                <Link
                  key={item.title}
                  to={item.href}
                  style={{
                    textDecoration: 'none',
                    color: 'white',
                    padding: '0px 18px 0px',
                  }}
                >
                  <Box
                    sx={{ ':hover': { color: '#fcc' }, fontWeight: 'medium' }}
                  >
                    {item.title}
                  </Box>
                </Link>
              );
            })}
          </Box>

          <MobileMenu />

          <Box sx={{ flexGrow: 0 }}>
            <ConnectKitButton />
          </Box>
        </Toolbar>
      </Container>
    </Box>
  );
}
export default Header;
